<template>
  <div :class="embedded ? 'city-paper-embedded-root' : 'role-page d-flex'">
    <aside v-if="!embedded" class="side-nav">
      <h4 class="mb-3">管理员系统</h4>
      <button class="sub-btn" :class="{ active: activeMenu === 'dashboard' }" type="button" @click="goAdminMenu('dashboard')">数据看板</button>
      <button class="sub-btn" :class="{ active: activeMenu === 'user' }" type="button" @click="goAdminMenu('user')">用户管理</button>
      <button class="sub-btn" :class="{ active: activeMenu === 'exam' }" type="button" @click="goAdminMenu('exam')">考试信息查询</button>
      <button class="sub-btn" :class="{ active: activeMenu === 'notice' }" type="button" @click="goAdminMenu('notice')">公告管理</button>
      <button class="sub-btn" :class="{ active: activeMenu === 'verifyAbnormal' }" type="button" @click="goAdminMenu('verifyAbnormal')">考试核验及异常行为管理</button>
      <button class="sub-btn" :class="{ active: activeMenu === 'eventManage' }" type="button" @click="goAdminMenu('eventManage')">赛事管理</button>
      <button class="sub-btn" :class="{ active: activeMenu === 'citySignup' }" type="button" @click="goAdminMenu('citySignup')">地市考试报名系统</button>
      <button class="sub-btn" :class="{ active: activeMenu === 'sessionManage' }" type="button" @click="goAdminMenu('sessionManage')">考试场次信息管理</button>
      <button class="sub-btn" :class="{ active: activeMenu === 'cityPaperManage' }" type="button" @click="goAdminMenu('cityPaperManage')">地市试卷设置管理</button>
      <div class="mt-auto">
        <button class="btn btn-success w-100 side-nav-logout-btn" type="button" @click="logout">退出登录</button>
      </div>
    </aside>

    <main class="content-area" :class="{ 'city-paper-embedded-main': embedded }">
      <header v-if="!embedded" class="topbar mb-3">
        <div>
          <h2 class="mb-1">地市试卷设置管理</h2>
          <p class="mb-0 text-muted">按参赛场次和赛项筛选学生，并批量加入考试</p>
        </div>
      </header>

      <section v-if="pageError" class="card-box city-paper-card ticket-section mb-3">
        <div class="ticket-section-head">
          <div class="ticket-section-head__text">
            <h4 class="ticket-section-title text-danger">页面加载异常</h4>
            <p class="ticket-section-desc">{{ pageError }}</p>
          </div>
        </div>
        <div class="ticket-form-actions" style="border-top: none; padding-top: 0; margin-top: 0;">
          <button class="btn btn-primary btn-sm" type="button" @click="recoverPage">重试加载</button>
          <button class="btn btn-light btn-sm" type="button" @click="pageError = ''">关闭提示</button>
        </div>
      </section>

      <section class="card-box city-paper-card ticket-section mb-3">
        <div class="ticket-section-head">
          <div class="ticket-section-head__text">
            <h4 class="ticket-section-title">1. 选择场次</h4>
            <p class="ticket-section-desc">按场次名称、省份、地市筛选报名场次，再选择要配置试卷的场次。</p>
          </div>
          <div class="d-flex flex-wrap align-items-center gap-2">
            <span class="small text-muted">共 {{ signupTotalElements }} 条 · {{ signupPage + 1 }}/{{ signupTotalPages }}</span>
            <button class="btn btn-light btn-sm" type="button" :disabled="signupPage <= 0" @click="changeSignupPage(signupPage - 1)">上一页</button>
            <button class="btn btn-light btn-sm" type="button" :disabled="signupPage >= signupTotalPages - 1" @click="changeSignupPage(signupPage + 1)">下一页</button>
          </div>
        </div>

        <div class="ticket-form-panel mb-3">
          <div class="row g-3 align-items-end">
            <div class="col-md-4 col-lg-3">
              <div class="ticket-field">
                <label class="ticket-field-label">场次名称</label>
                <select v-model="sessionFilters.examName" class="form-select">
                  <option value="">全部场次</option>
                  <option v-for="name in signupExamNameOptions" :key="'signup-exam-' + name" :value="name">{{ name }}</option>
                </select>
              </div>
            </div>
            <div class="col-md-4 col-lg-3">
              <div class="ticket-field">
                <label class="ticket-field-label">省份</label>
                <select v-model="sessionFilters.province" class="form-select">
                  <option value="">全部省份</option>
                  <option v-for="p in signupProvinceOptions" :key="'signup-province-' + p" :value="p">{{ p }}</option>
                </select>
              </div>
            </div>
            <div class="col-md-4 col-lg-3">
              <div class="ticket-field">
                <label class="ticket-field-label">地市</label>
                <select v-model="sessionFilters.city" class="form-select">
                  <option value="">全部地市</option>
                  <option v-for="c in signupCityOptions" :key="'signup-city-' + c" :value="c">{{ c }}</option>
                </select>
              </div>
            </div>
            <div class="col-md-4 col-lg-3">
              <div class="ticket-field">
                <label class="ticket-field-label">&nbsp;</label>
                <button class="btn btn-primary w-100" type="button" @click="loadSignups">查询场次</button>
              </div>
            </div>
          </div>
        </div>

        <div class="city-paper-result-shell">
          <table class="table table-striped align-middle modern-table mb-0">
            <thead>
              <tr>
                <th>ID</th>
                <th>场次</th>
                <th>地市</th>
                <th>考试时间</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in signupRows" :key="'signup-' + row.id">
                <td>{{ row.id }}</td>
                <td class="ticket-cell-wrap">{{ row.examName || '-' }}</td>
                <td>{{ row.province || '-' }} {{ row.city || '' }}</td>
                <td>{{ fmtDateTime(row.examTime) }}</td>
                <td>
                  <button class="btn btn-sm btn-primary" type="button" @click="selectSignup(row)">选择此场次</button>
                </td>
              </tr>
              <tr v-if="signupRows.length === 0">
                <td colspan="5" class="text-muted py-4">暂无场次数据，请调整筛选条件后重试。</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section class="card-box city-paper-card ticket-section mb-3" v-if="selectedSignupId">
        <div class="ticket-section-head">
          <div class="ticket-section-head__text">
            <h4 class="ticket-section-title">2. 筛选学生</h4>
            <p class="ticket-section-desc">
              当前场次：{{ selectedSignupTitle }}。可按姓名、赛项、审核状态筛选；未建号学生可先补生成考试账号，再勾选加入考试。
            </p>
          </div>
          <div class="d-flex flex-wrap align-items-center gap-2">
            <span class="small text-muted">共 {{ entryTotalElements }} 条 · {{ entryPage + 1 }}/{{ entryTotalPages }}</span>
            <button class="btn btn-light btn-sm" type="button" :disabled="entryPage <= 0" @click="changeEntryPage(entryPage - 1)">上一页</button>
            <button class="btn btn-light btn-sm" type="button" :disabled="entryPage >= entryTotalPages - 1" @click="changeEntryPage(entryPage + 1)">下一页</button>
          </div>
        </div>

        <div class="ticket-form-panel mb-3">
          <div class="row g-3 align-items-end">
            <div class="col-md-4 col-lg-3">
              <div class="ticket-field">
                <label class="ticket-field-label">姓名</label>
                <input v-model.trim="entryFilters.candidateName" class="form-control" placeholder="可选，支持模糊匹配" />
              </div>
            </div>
            <div class="col-md-4 col-lg-3">
              <div class="ticket-field">
                <label class="ticket-field-label">赛项</label>
                <select v-model="entryFilters.projectName" class="form-select">
                  <option value="">全部赛项</option>
                  <option v-for="p in projectOptions" :key="'proj-' + p" :value="p">{{ p }}</option>
                </select>
              </div>
            </div>
            <div class="col-md-4 col-lg-2">
              <div class="ticket-field">
                <label class="ticket-field-label">状态</label>
                <select v-model="entryFilters.status" class="form-select">
                  <option value="">全部</option>
                  <option value="2">通过</option>
                  <option value="1">待审</option>
                  <option value="0">驳回</option>
                </select>
              </div>
            </div>
            <div class="col-md-4 col-lg-2">
              <div class="ticket-field">
                <label class="ticket-field-label">&nbsp;</label>
                <button class="btn btn-primary w-100" type="button" @click="loadEntries">查询学生</button>
              </div>
            </div>
            <div class="col-12">
              <div class="ticket-action-row">
                <button class="btn btn-light btn-sm" type="button" :disabled="batchGeneratingAccounts" @click="batchGenerateExamAccounts(false)">
                  {{ batchGeneratingAccounts ? '生成中…' : '当前页补生成账号' }}
                </button>
                <button class="btn btn-light btn-sm" type="button" :disabled="batchGeneratingAccounts" @click="batchGenerateExamAccounts(true)">
                  {{ batchGeneratingAccounts ? '处理中…' : '全部筛选补生成账号' }}
                </button>
                <button class="btn btn-light btn-sm" type="button" @click="toggleCurrentPageEntries">
                  {{ allEntrySelectedOnPage ? '取消全选当前页' : '全选当前页' }}
                </button>
                <button class="btn btn-light btn-sm" type="button" @click="toggleAllFilteredEntries">
                  {{ allEntrySelected ? '取消全选筛选结果' : '全选筛选结果' }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="ticket-stats-bar small mb-3">
          <span>可加入学生需审核状态为「通过/待审」，且已生成考试账号；驳回不可选。</span>
        </div>

        <div v-if="generatedAccounts.length" class="city-paper-result-shell mb-3">
          <div class="ticket-section-head mb-2" style="margin-bottom: 10px !important;">
            <div class="ticket-section-head__text">
              <h5 class="ticket-section-title" style="font-size: 1rem;">本次新生成账号</h5>
              <p class="ticket-section-desc">请及时保存密码，仅展示本次生成结果。</p>
            </div>
          </div>
          <table class="table table-striped align-middle modern-table mb-0">
            <thead>
              <tr>
                <th>报名ID</th>
                <th>姓名</th>
                <th>考试账号</th>
                <th>初始密码</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="x in generatedAccounts" :key="'ga-' + x.entryId">
                <td>{{ x.entryId }}</td>
                <td>{{ x.candidateName || '-' }}</td>
                <td>{{ x.username || '-' }}</td>
                <td>{{ x.plainPassword || '-' }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="city-paper-result-shell">
          <table class="table table-striped align-middle modern-table mb-0">
            <thead>
              <tr>
                <th style="width: 56px;">
                  <input type="checkbox" :checked="allEntrySelectedOnPage" @change="toggleCurrentPageEntries" />
                </th>
                <th>姓名</th>
                <th>赛项</th>
                <th>状态</th>
                <th>考试账号</th>
                <th>用户ID</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in entryRowsPaged" :key="'entry-' + row.id">
                <td>
                  <input
                    type="checkbox"
                    :checked="selectedUserIdsSet.has(Number(row.generatedUserId))"
                    :disabled="!isEntryAssignable(row)"
                    @change="toggleEntry(row, $event)"
                  />
                </td>
                <td>{{ row.candidateName || '-' }}</td>
                <td class="ticket-cell-wrap">{{ row.projectName || '-' }}</td>
                <td>
                  <span
                    class="ticket-status-badge"
                    :class="Number(row.status) === 2 ? 'is-on' : (Number(row.status) === 0 ? 'is-off' : 'is-pending')"
                  >
                    {{ entryStatusText(row.status) }}
                  </span>
                </td>
                <td>{{ row.generatedExamUsername || '-' }}</td>
                <td>{{ row.generatedUserId || '-' }}</td>
              </tr>
              <tr v-if="entryRowsPaged.length === 0">
                <td colspan="6" class="text-muted py-4">暂无学生数据</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section class="card-box city-paper-card ticket-section mb-3" v-if="selectedSignupId">
        <div class="ticket-section-head">
          <div class="ticket-section-head__text">
            <h4 class="ticket-section-title">3. 创建考试并加入学生</h4>
            <p class="ticket-section-desc">填写考试信息后，将上方已勾选学生写入参考名单。可仅创建，或创建并立即发布。</p>
          </div>
        </div>
        <div class="ticket-form-panel">
          <div class="row g-3">
            <div class="col-md-6 col-lg-3">
              <div class="ticket-field">
                <label class="ticket-field-label">考试名称</label>
                <input v-model.trim="examForm.examName" class="form-control" placeholder="如：市赛理论考试" />
              </div>
            </div>
            <div class="col-md-6 col-lg-3">
              <div class="ticket-field">
                <label class="ticket-field-label">绑定试卷</label>
                <select v-model.number="examForm.paperId" class="form-select">
                  <option :value="null">请选择试卷</option>
                  <option v-for="p in papers" :key="'paper-' + p.id" :value="Number(p.id)">
                    {{ p.paperName }} (ID: {{ p.id }})
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-6 col-lg-3">
              <div class="ticket-field">
                <label class="ticket-field-label">开始时间</label>
                <input v-model="examForm.startTime" type="datetime-local" class="form-control" />
              </div>
            </div>
            <div class="col-md-6 col-lg-3">
              <div class="ticket-field">
                <label class="ticket-field-label">结束时间</label>
                <input v-model="examForm.endTime" type="datetime-local" class="form-control" />
              </div>
            </div>
          </div>
          <div class="ticket-form-actions">
            <span class="ticket-selected-count">已选择学生：{{ selectedUserIds.length }} 人</span>
            <button class="btn btn-light" type="button" @click="loadPapers">刷新试卷</button>
            <button class="btn btn-primary" type="button" :disabled="savingExam" @click="createExam(false)">
              {{ savingExam ? '创建中…' : '创建考试' }}
            </button>
            <button class="btn btn-primary" type="button" :disabled="savingExam" @click="createExam(true)">
              {{ savingExam ? '处理中…' : '创建并发布' }}
            </button>
          </div>
        </div>
      </section>

      <section class="card-box city-paper-card ticket-section mb-3" v-if="selectedSignupId">
        <div class="ticket-section-head">
          <div class="ticket-section-head__text">
            <h4 class="ticket-section-title">4. 已创建考试</h4>
            <p class="ticket-section-desc">可编辑考试信息与参考人员；参考人员在表格下方展开编辑，无需弹窗。</p>
          </div>
          <div class="d-flex flex-wrap align-items-center gap-2">
            <label class="ticket-check mb-0">
              <input v-model="onlyShowCurrentSessionExams" type="checkbox" class="form-check-input" />
              <span class="form-check-label">仅显示当前场次考试</span>
            </label>
            <button class="btn btn-light btn-sm" type="button" @click="loadExamList">刷新列表</button>
          </div>
        </div>

        <div class="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3">
          <span class="small text-muted">共 {{ examTotalElements }} 条 · 第 {{ examPage + 1 }}/{{ examTotalPages }} 页</span>
          <div class="d-flex align-items-center gap-2">
            <button class="btn btn-light btn-sm" type="button" :disabled="examPage <= 0" @click="changeExamPage(examPage - 1)">上一页</button>
            <button class="btn btn-light btn-sm" type="button" :disabled="examPage >= examTotalPages - 1" @click="changeExamPage(examPage + 1)">下一页</button>
          </div>
        </div>

        <div class="city-paper-result-shell mb-3">
          <table class="table table-striped align-middle modern-table mb-0">
            <thead>
              <tr>
                <th>ID</th>
                <th>考试名称</th>
                <th>试卷</th>
                <th>时间</th>
                <th>已分配人数</th>
                <th>状态</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in examListPaged" :key="'exam-' + examItemId(item)">
                <td>{{ examItemId(item) }}</td>
                <td class="ticket-cell-wrap">{{ examItem(item).examName || '-' }}</td>
                <td class="ticket-cell-wrap">{{ item.paperName || ('#' + (examItem(item).paperId || '-')) }}</td>
                <td class="ticket-cell-wrap">{{ fmtDateTime(examItem(item).startTime) }} ~ {{ fmtDateTime(examItem(item).endTime) }}</td>
                <td>{{ (item.participantUserIds || []).length }}</td>
                <td>
                  <span class="ticket-status-badge" :class="examStatusBadgeClass(examItem(item).status)">
                    {{ examStatusText(examItem(item).status) }}
                  </span>
                </td>
                <td>
                  <div class="ticket-action-row">
                    <button class="btn btn-sm btn-light" type="button" @click="openExamEditModal(item)">编辑考试</button>
                    <button class="btn btn-sm btn-primary" type="button" @click="openParticipantEditor(item)">编辑参考人员</button>
                    <button class="btn btn-sm btn-outline-success" type="button" @click="exportParticipantsForExam(examItemId(item), examItem(item).examName)">导出学生</button>
                    <button class="btn btn-sm btn-light" type="button" @click="publishExam(examItemId(item))">发布</button>
                    <button class="btn btn-sm btn-light" type="button" @click="cancelExam(examItemId(item))">取消</button>
                    <button class="btn btn-sm btn-danger ticket-danger-btn" type="button" @click="deleteExam(examItemId(item))">删除</button>
                  </div>
                </td>
              </tr>
              <tr v-if="examListPaged.length === 0">
                <td colspan="7" class="text-muted py-4">暂无考试记录</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div
          v-if="showParticipantEditor"
          ref="participantInlinePanel"
          class="city-paper-participant-inline"
        >
          <div class="ticket-section-head">
            <div class="ticket-section-head__text">
              <h5 class="ticket-section-title" style="font-size: 1.05rem;">编辑参考人员 · {{ participantEditor.examName || '-' }}</h5>
              <p class="ticket-section-desc">
                当前人数：{{ participantEditor.userIds.length }} 人。支持当前筛选批量操作、考试账号批量添加与手工 ID 编辑。
              </p>
            </div>
            <div class="d-flex gap-2 flex-wrap">
              <button class="btn btn-sm btn-success" type="button" :disabled="!participantEditor.examId" @click="exportParticipantsForExam(participantEditor.examId, participantEditor.examName)">导出学生名单</button>
              <button class="btn btn-sm btn-light" type="button" :disabled="!participantEditor.examId || participantDetailLoading" @click="loadParticipantDetails(participantEditor.examId)">
                {{ participantDetailLoading ? '刷新中…' : '刷新名单(含导入人)' }}
              </button>
              <button class="btn btn-sm btn-light ticket-section-head__action" type="button" @click="closeParticipantEditor">收起</button>
            </div>
          </div>

          <div v-if="participantDetailRows.length" class="result-shell mb-3">
            <div v-if="adminImporterSummary.length" class="alert alert-light border py-2 px-3 mb-2 small">
              <div class="fw-semibold mb-1">导入人汇总</div>
              <div class="d-flex flex-wrap gap-2">
                <span v-for="item in adminImporterSummary" :key="'ais-' + item.name" class="badge text-bg-secondary">
                  {{ item.name }}：{{ item.count }} 人
                </span>
              </div>
            </div>
            <table class="table table-sm table-striped align-middle mb-0">
              <thead>
                <tr>
                  <th>用户ID</th>
                  <th>账号</th>
                  <th>姓名</th>
                  <th>准考证</th>
                  <th>状态</th>
                  <th>导入教师</th>
                  <th>导入时间</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="r in participantDetailRows" :key="'pd-' + r.userId">
                  <td>{{ r.userId }}</td>
                  <td>{{ r.username || '-' }}</td>
                  <td>{{ r.realName || '-' }}</td>
                  <td>{{ r.ticketNo || '-' }}</td>
                  <td>{{ r.status || '-' }}</td>
                  <td>{{ r.assignedByName || (r.assignedBy ? ('ID:' + r.assignedBy) : '-') }}</td>
                  <td>{{ fmtDateTime(r.assignedAt) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else-if="participantDetailLoaded" class="small text-muted mb-3">暂无参考人员明细（或接口未返回数据）</div>

          <div class="participant-card-grid">
            <div class="participant-edit-card">
              <div class="participant-edit-card__title">A. 当前筛选批量操作</div>
              <div class="ticket-action-row">
                <button class="btn btn-sm btn-light" type="button" @click="applyCurrentSelectionToEditor">用当前筛选学生覆盖</button>
                <button class="btn btn-sm btn-light" type="button" @click="appendCurrentSelectionToEditor">追加当前筛选学生</button>
                <button class="btn btn-sm btn-light" type="button" @click="removeCurrentSelectionFromEditor">移除当前筛选学生</button>
              </div>
            </div>

            <div class="participant-edit-card">
              <div class="participant-edit-card__title">B. 按考试账号批量添加</div>
              <div class="ticket-field">
                <label class="ticket-field-label">考试账号（换行 / 逗号分隔）</label>
                <textarea
                  v-model="participantEditor.usernamesText"
                  class="form-control"
                  rows="4"
                  placeholder="例如：12300001,12300002"
                />
              </div>
              <div class="ticket-action-row mt-3">
                <button class="btn btn-sm btn-light" type="button" @click="downloadParticipantTemplate">下载Excel模板</button>
                <label class="btn btn-sm btn-light mb-0">
                  选择Excel
                  <input type="file" class="d-none" accept=".xlsx,.xls" @change="onParticipantExcelChange" />
                </label>
                <button class="btn btn-sm btn-light" type="button" :disabled="participantEditorImporting || !participantEditorExcelFile" @click="importParticipantsByExcel">
                  {{ participantEditorImporting ? '导入中…' : 'Excel导入账号' }}
                </button>
                <button class="btn btn-sm btn-primary" type="button" :disabled="participantEditorResolving" @click="appendParticipantsByUsernames">
                  {{ participantEditorResolving ? '解析中…' : '按账号追加' }}
                </button>
              </div>
              <div class="small text-muted mt-2">
                {{ participantEditorExcelFile ? ('已选择：' + participantEditorExcelFile.name) : '未选择Excel文件' }}
              </div>
              <div v-if="participantEditorImportSummary" class="small mt-1 text-success">
                {{ participantEditorImportSummary }}
              </div>
            </div>

            <div class="participant-edit-card">
              <div class="participant-edit-card__title">C. 参考人员ID编辑</div>
              <div class="ticket-field">
                <label class="ticket-field-label">参考人员ID（逗号分隔）</label>
                <textarea
                  v-model="participantEditor.userIdsText"
                  class="form-control"
                  rows="6"
                  placeholder="例如：1001,1002,1003"
                />
              </div>
            </div>
          </div>

          <div class="ticket-form-actions">
            <button class="btn btn-primary" type="button" :disabled="participantEditorSaving" @click="saveParticipantEditor">
              {{ participantEditorSaving ? '保存中…' : '保存参考人员' }}
            </button>
          </div>
        </div>
      </section>
    </main>

    <!-- 挂到 body，避免嵌套在管理员主区域产生堆叠上下文导致遮罩盖不住左侧导航 -->
    <Teleport to="body">
      <div v-if="showExamEditModal" class="city-paper-modal-mask" @click.self="closeExamEditModal">
        <div class="modal-panel city-exam-edit-modal" @click.stop>
          <div class="ticket-section-head mb-3">
            <div class="ticket-section-head__text">
              <h5 class="ticket-section-title" style="font-size: 1.05rem;">编辑考试</h5>
              <p class="ticket-section-desc">
                与教师端考试管理一致：可修改名称、试卷、时间及参考人员用户ID；保存后按当前时间刷新状态。
              </p>
            </div>
            <button class="btn btn-sm btn-light" type="button" @click="closeExamEditModal">关闭</button>
          </div>
          <div
            v-if="examEditFeedback"
            class="alert mb-3 py-2 px-3 small"
            :class="examEditFeedback.ok ? 'alert-success' : 'alert-danger'"
            role="alert"
          >
            {{ examEditFeedback.text }}
          </div>
          <div class="ticket-form-panel">
            <div class="row g-3">
              <div class="col-md-6">
                <div class="ticket-field">
                  <label class="ticket-field-label">考试名称</label>
                  <input v-model="examEditForm.examName" class="form-control" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="ticket-field">
                  <label class="ticket-field-label">绑定试卷</label>
                  <select v-model.number="examEditForm.paperId" class="form-select">
                    <option :value="null">请选择试卷</option>
                    <option v-for="p in papers" :key="'exam-edit-p-' + p.id" :value="p.id">{{ p.paperName }}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="ticket-field">
                  <label class="ticket-field-label">开始时间</label>
                  <input v-model="examEditForm.startTime" type="datetime-local" class="form-control" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="ticket-field">
                  <label class="ticket-field-label">结束时间</label>
                  <input v-model="examEditForm.endTime" type="datetime-local" class="form-control" />
                </div>
              </div>
              <div class="col-12">
                <div class="ticket-field">
                  <label class="ticket-field-label">参考人员用户ID（逗号分隔，可选）</label>
                  <textarea
                    v-model="examEditForm.participantUserIdsText"
                    class="form-control"
                    rows="3"
                    placeholder="例如：1001,1002,1003"
                  />
                </div>
              </div>
            </div>
            <div class="ticket-form-actions">
              <button class="btn btn-light" type="button" @click="closeExamEditModal">取消</button>
              <button class="btn btn-primary" type="button" :disabled="examEditSaving" @click="saveExamEdit">
                {{ examEditSaving ? '保存中…' : '保存修改' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script>
import { appConfirm } from '../utils/appDialog'

export default {
  name: 'AdminCityPaperManageView',
  props: {
    embedded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      user: {},
      activeMenu: 'cityPaperManage',
      sessionFilters: {
        examName: '',
        province: '',
        city: ''
      },
      signupFilterRows: [],
      signupRows: [],
      signupPage: 0,
      signupPageSize: 10,
      signupTotalPages: 1,
      signupTotalElements: 0,
      selectedSignupId: null,
      selectedSignupTitle: '',
      entryFilters: {
        candidateName: '',
        projectName: '',
        status: ''
      },
      entryProjectOptions: [],
      entryRows: [],
      entryPage: 0,
      entryPageSize: 10,
      selectedUserIds: [],
      papers: [],
      examForm: {
        examName: '',
        paperId: null,
        startTime: '',
        endTime: ''
      },
      savingExam: false,
      examList: [],
      examPage: 0,
      examPageSize: 10,
      showExamEditModal: false,
      examEditSaving: false,
      examEditForm: {
        id: null,
        examName: '',
        paperId: null,
        startTime: '',
        endTime: '',
        participantUserIdsText: ''
      },
      /** 编辑考试弹窗内反馈（保存成功/失败） */
      examEditFeedback: null,
      examEditSuccessTimer: null,
      showParticipantEditor: false,
      onlyShowCurrentSessionExams: true,
      pageError: '',
      batchGeneratingAccounts: false,
      generatedAccounts: [],
      participantEditorSaving: false,
      participantEditorResolving: false,
      participantEditorImporting: false,
      participantEditorExcelFile: null,
      participantEditorImportSummary: '',
      participantDetailRows: [],
      participantDetailLoading: false,
      participantDetailLoaded: false,
      participantEditor: {
        examId: null,
        examName: '',
        paperId: null,
        startTime: '',
        endTime: '',
        userIdsText: '',
        usernamesText: '',
        userIds: []
      }
    }
  },
  computed: {
    projectOptions() {
      return Array.from(
        new Set(
          (this.entryProjectOptions || [])
            .map((x) => String(x.projectName || '').trim())
            .filter((x) => !!x)
        )
      )
    },
    adminImporterSummary() {
      const map = new Map()
      ;(this.participantDetailRows || []).forEach((r) => {
        let name = String((r && r.assignedByName) || '').trim()
        if (!name && r && r.assignedBy) name = `ID:${r.assignedBy}`
        if (!name) name = '(未记录导入人)'
        map.set(name, (map.get(name) || 0) + 1)
      })
      return Array.from(map.entries())
        .map(([name, count]) => ({ name, count }))
        .sort((a, b) => b.count - a.count || a.name.localeCompare(b.name, 'zh-CN'))
    },
    selectedUserIdsSet() {
      return new Set((this.selectedUserIds || []).map((x) => Number(x)))
    },
    allEntrySelected() {
      const assignable = (this.entryRows || []).filter((x) => this.isEntryAssignable(x))
      if (!assignable.length) return false
      const set = this.selectedUserIdsSet
      return assignable.every((x) => set.has(Number(x.generatedUserId)))
    },
    allEntrySelectedOnPage() {
      const assignable = (this.entryRowsPaged || []).filter((x) => this.isEntryAssignable(x))
      if (!assignable.length) return false
      const set = this.selectedUserIdsSet
      return assignable.every((x) => set.has(Number(x.generatedUserId)))
    },
    signupProvinceOptions() {
      return Array.from(
        new Set(
          (this.signupFilterRows || [])
            .map((x) => String(x.province || '').trim())
            .filter((x) => !!x)
        )
      )
    },
    signupCityOptions() {
      const province = String(this.sessionFilters.province || '').trim()
      const rows = (this.signupFilterRows || []).filter((x) => {
        if (!province) return true
        return String(x.province || '').trim() === province
      })
      return Array.from(
        new Set(
          rows.map((x) => String(x.city || '').trim()).filter((x) => !!x)
        )
      )
    },
    signupExamNameOptions() {
      const province = String(this.sessionFilters.province || '').trim()
      const city = String(this.sessionFilters.city || '').trim()
      const rows = (this.signupFilterRows || []).filter((x) => {
        if (province && String(x.province || '').trim() !== province) return false
        if (city && String(x.city || '').trim() !== city) return false
        return true
      })
      return Array.from(
        new Set(
          rows.map((x) => String(x.examName || '').trim()).filter((x) => !!x)
        )
      )
    },
    entryTotalElements() {
      return (this.entryRows || []).length
    },
    entryTotalPages() {
      const size = Number(this.entryPageSize) || 10
      const total = this.entryTotalElements
      const pages = Math.ceil(total / Math.max(1, size))
      return pages < 1 ? 1 : pages
    },
    entryRowsPaged() {
      const rows = this.entryRows || []
      const size = Number(this.entryPageSize) || 10
      const page = Number(this.entryPage) || 0
      const start = page * size
      return rows.slice(start, start + size)
    },
    examListVisible() {
      const list = Array.isArray(this.examList) ? this.examList : []
      if (!this.onlyShowCurrentSessionExams) return list
      const key = String(this.selectedSignupTitle || '').trim()
      if (!key) return list
      return list.filter((item) => String(item && item.exam && item.exam.examName ? item.exam.examName : '').includes(key))
    },
    examTotalElements() {
      return (this.examListVisible || []).length
    },
    examTotalPages() {
      const size = Number(this.examPageSize) || 10
      const total = this.examTotalElements
      const pages = Math.ceil(total / Math.max(1, size))
      return pages < 1 ? 1 : pages
    },
    examListPaged() {
      const list = this.examListVisible || []
      const size = Number(this.examPageSize) || 10
      const page = Number(this.examPage) || 0
      const start = page * size
      return list.slice(start, start + size)
    }
  },
  created() {
    try {
      this.user = JSON.parse(localStorage.getItem('exam_user') || '{}')
    } catch (e) {
      this.user = {}
    }
    this.loadSignups()
    this.loadSignupFilterOptions()
    this.loadPapers()
    this.loadExamList()
  },
  mounted() {
    // Ensure first entry renders data immediately after route switch.
    this.$nextTick(() => {
      if (!this.signupRows.length) this.loadSignups()
      if (!this.signupFilterRows.length) this.loadSignupFilterOptions()
      if (!this.papers.length) this.loadPapers()
    })
  },
  watch: {
    onlyShowCurrentSessionExams() {
      this.examPage = 0
    },
    selectedSignupTitle() {
      this.examPage = 0
    }
  },
  methods: {
    setPageError(err, context = '') {
      const msg = err && err.message ? String(err.message) : String(err || '未知错误')
      this.pageError = context ? `${context}：${msg}` : msg
    },
    recoverPage() {
      this.pageError = ''
      this.loadSignups()
      this.loadSignupFilterOptions()
      this.loadPapers()
      this.loadExamList()
      if (this.selectedSignupId) {
        this.loadEntryProjectOptions()
        this.loadEntries()
      }
    },
    examItem(item) {
      return item && item.exam && typeof item.exam === 'object' ? item.exam : (item || {})
    },
    examItemId(item) {
      const id = Number(this.examItem(item).id)
      return Number.isFinite(id) ? id : 0
    },
    goAdminMenu(key) {
      const k = String(key || 'dashboard').trim()
      try {
        localStorage.setItem('admin_active_menu', k)
      } catch (e) {
        void e
      }
      if (k === 'eventManage') {
        window.location.hash = '#/home/city-signup?adminTab=eventManage'
        return
      }
      if (k === 'citySignup') {
        window.location.hash = '#/home/city-signup?adminTab=citySignup'
        return
      }
      if (k === 'sessionManage') {
        window.location.hash = '#/home/exam-session-info'
        return
      }
      if (k === 'cityPaperManage') {
        window.location.hash = '#/home/city-paper-manage'
        return
      }
      window.location.hash = '#/admin/home'
    },
    logout() {
      localStorage.removeItem('exam_user')
      window.location.hash = '#/'
    },
    authHeaders(extra = {}, role = 'admin') {
      return {
        'X-Role': role,
        'X-User-Id': this.user && this.user.id != null ? String(this.user.id) : '',
        'X-Username': this.user && this.user.username ? String(this.user.username) : role,
        'X-CSRF-Token': 'exam-ui',
        ...extra
      }
    },
    fmtDateTime(v) {
      if (!v) return '-'
      const t = String(v).replace(' ', 'T')
      const d = new Date(t)
      if (Number.isNaN(d.getTime())) return String(v)
      const pad = (n) => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`
    },
    entryStatusText(s) {
      const v = Number(s)
      if (v === 2) return '通过'
      if (v === 1) return '待审'
      if (v === 0) return '驳回'
      return '-'
    },
    examStatusText(status) {
      const s = String(status || '').toUpperCase()
      if (s === 'NOT_START') return '未开始'
      if (s === 'ING') return '进行中'
      if (s === 'END') return '已结束'
      return status || '-'
    },
    examStatusBadgeClass(status) {
      const s = String(status || '').toUpperCase()
      if (s === 'ING') return 'is-on'
      if (s === 'END') return 'is-off'
      return 'is-pending'
    },
    isEntryAssignable(row) {
      if (!row) return false
      const uid = Number(row.generatedUserId)
      const status = Number(row.status)
      return status !== 0 && Number.isFinite(uid) && uid > 0
    },
    loadSignupFilterOptions() {
      const params = new URLSearchParams({
        page: '0',
        size: '500',
        sortBy: 'id',
        sort: 'desc'
      })
      fetch(`/api/crud/city-exam-signup?${params.toString()}`)
        .then((r) => r.json())
        .then((res) => {
          this.signupFilterRows = (res && res.data && res.data.content) || []
        })
        .catch(() => {
          this.signupFilterRows = []
        })
    },
    changeSignupPage(nextPage) {
      const page = Number(nextPage)
      if (!Number.isFinite(page)) return
      if (page < 0 || page >= this.signupTotalPages) return
      this.signupPage = page
      this.loadSignups()
    },
    changeEntryPage(nextPage) {
      const page = Number(nextPage)
      if (!Number.isFinite(page)) return
      if (page < 0 || page >= this.entryTotalPages) return
      this.entryPage = page
    },
    changeExamPage(nextPage) {
      const page = Number(nextPage)
      if (!Number.isFinite(page)) return
      if (page < 0 || page >= this.examTotalPages) return
      this.examPage = page
    },
    loadSignups() {
      const params = new URLSearchParams({
        page: String(this.signupPage),
        size: String(this.signupPageSize),
        sortBy: 'id',
        sort: 'desc'
      })
      const f = this.sessionFilters || {}
      if (f.examName) params.append('examNameLike', f.examName)
      if (f.province) params.append('province', f.province)
      if (f.city) params.append('city', f.city)
      fetch(`/api/crud/city-exam-signup?${params.toString()}`)
        .then((r) => r.json())
        .then((res) => {
          const data = (res && res.data) || {}
          this.signupRows = data.content || []
          this.signupTotalPages = Number(data.totalPages || 1) || 1
          this.signupTotalElements = Number(data.totalElements || this.signupRows.length) || 0
          if (this.signupPage >= this.signupTotalPages) {
            this.signupPage = Math.max(0, this.signupTotalPages - 1)
          }
        })
        .catch((e) => {
          this.signupRows = []
          this.signupTotalPages = 1
          this.signupTotalElements = 0
          this.setPageError(e, '加载场次失败')
        })
    },
    selectSignup(row) {
      if (!row || !row.id) return
      this.selectedSignupId = Number(row.id)
      this.selectedSignupTitle = row.examName || `场次#${row.id}`
      this.selectedUserIds = []
      this.generatedAccounts = []
      if (!this.examForm.examName) {
        this.examForm.examName = `${this.selectedSignupTitle}-地市考试`
      }
      this.entryPage = 0
      this.loadEntryProjectOptions()
      this.loadEntries()
    },
    loadEntryProjectOptions() {
      if (!this.selectedSignupId) {
        this.entryProjectOptions = []
        return
      }
      const params = new URLSearchParams({ signupId: String(this.selectedSignupId) })
      fetch(`/api/admin/city-signup-entry/list?${params.toString()}`, {
        headers: this.authHeaders()
      })
        .then((r) => r.json())
        .then((res) => {
          this.entryProjectOptions = Array.isArray(res && res.data) ? res.data : []
        })
        .catch(() => {
          this.entryProjectOptions = []
        })
    },
    loadEntries() {
      if (!this.selectedSignupId) return
      const params = new URLSearchParams({
        signupId: String(this.selectedSignupId)
      })
      if (this.entryFilters.candidateName) params.append('candidateName', this.entryFilters.candidateName)
      if (this.entryFilters.projectName) params.append('projectName', this.entryFilters.projectName)
      if (this.entryFilters.status !== '') params.append('status', String(this.entryFilters.status))
      return fetch(`/api/admin/city-signup-entry/list?${params.toString()}`, {
        headers: this.authHeaders()
      })
        .then((r) => r.json())
        .then((res) => {
          this.entryRows = Array.isArray(res && res.data) ? res.data : []
          this.entryPage = 0
          const available = new Set(
            this.entryRows
              .filter((x) => this.isEntryAssignable(x))
              .map((x) => Number(x.generatedUserId))
          )
          this.selectedUserIds = this.selectedUserIds.filter((id) => available.has(Number(id)))
        })
        .catch(() => {
          this.entryRows = []
          this.setPageError('请检查接口权限或网络状态', '加载学生失败')
        })
    },
    toggleEntry(row, ev) {
      if (!this.isEntryAssignable(row)) return
      const checked = Boolean(ev && ev.target && ev.target.checked)
      const uid = Number(row.generatedUserId)
      const set = new Set(this.selectedUserIds.map((x) => Number(x)))
      if (checked) set.add(uid)
      else set.delete(uid)
      this.selectedUserIds = Array.from(set)
    },
    toggleCurrentPageEntries() {
      const assignable = (this.entryRowsPaged || []).filter((x) => this.isEntryAssignable(x)).map((x) => Number(x.generatedUserId))
      if (!assignable.length) return
      if (this.allEntrySelectedOnPage) {
        const drop = new Set(assignable)
        this.selectedUserIds = this.selectedUserIds.filter((id) => !drop.has(Number(id)))
        return
      }
      const set = new Set(this.selectedUserIds.map((x) => Number(x)))
      assignable.forEach((id) => set.add(id))
      this.selectedUserIds = Array.from(set)
    },
    toggleAllFilteredEntries() {
      const assignable = (this.entryRows || []).filter((x) => this.isEntryAssignable(x)).map((x) => Number(x.generatedUserId))
      if (!assignable.length) return
      if (this.allEntrySelected) {
        const drop = new Set(assignable)
        this.selectedUserIds = this.selectedUserIds.filter((id) => !drop.has(Number(id)))
        return
      }
      const set = new Set(this.selectedUserIds.map((x) => Number(x)))
      assignable.forEach((id) => set.add(id))
      this.selectedUserIds = Array.from(set)
    },
    async batchGenerateExamAccounts(forAllFiltered) {
      if (!this.selectedSignupId) return
      this.batchGeneratingAccounts = true
      try {
        const entryIds = (forAllFiltered ? this.entryRows : this.entryRowsPaged)
          .map((x) => Number(x && x.id))
          .filter((x) => Number.isFinite(x) && x > 0)
        const payload = {
          signupId: this.selectedSignupId,
          entryIds
        }
        const res = await fetch('/api/admin/city-signup-entry/batch-generate-account', {
          method: 'POST',
          headers: this.authHeaders({ 'Content-Type': 'application/json' }),
          body: JSON.stringify(payload)
        }).then((r) => r.json())
        if (!res || res.code !== 200) {
          window.alert((res && res.message) || '批量生成考试账号失败')
          return
        }
        const data = res.data || {}
        this.generatedAccounts = Array.isArray(data.accounts) ? data.accounts : []
        await this.loadEntries()
        this.loadEntryProjectOptions()
        const created = Number(data.created || 0)
        const skipped = Number(data.skipped || 0)
        window.alert(`处理完成：新生成 ${created} 个，跳过 ${skipped} 个`)
      } catch (e) {
        this.setPageError(e, '批量生成考试账号失败')
        window.alert('批量生成考试账号失败')
      } finally {
        this.batchGeneratingAccounts = false
      }
    },
    loadPapers() {
      const params = new URLSearchParams({
        page: '0',
        size: '500',
        sortBy: 'id',
        sort: 'desc'
      })
      fetch(`/api/crud/exam-paper?${params.toString()}`)
        .then((r) => r.json())
        .then((res) => {
          this.papers = (res && res.data && res.data.content) || []
        })
        .catch((e) => {
          this.papers = []
          this.setPageError(e, '加载试卷失败')
        })
    },
    loadExamList() {
      const params = new URLSearchParams({ page: '0', size: '200' })
      fetch(`/api/teacher/exam-manage/list?${params.toString()}`, {
        headers: this.authHeaders()
      })
        .then((r) => r.json())
        .then((res) => {
          const data = res && res.data
          const list = Array.isArray(data) ? data : ((data && data.content) || [])
          this.examList = (res && res.code === 200)
            ? list.filter((x) => x && typeof x === 'object')
            : []
          if (this.examPage >= this.examTotalPages) {
            this.examPage = Math.max(0, this.examTotalPages - 1)
          }
        })
        .catch((e) => {
          this.examList = []
          this.examPage = 0
          this.setPageError(e, '加载考试列表失败')
        })
    },
    parseIds(text) {
      return Array.from(
        new Set(
          String(text || '')
            .split(/[\s,，;；\n\r\t]+/)
            .map((x) => Number(String(x).trim()))
            .filter((x) => Number.isFinite(x) && x > 0)
        )
      )
    },
    /** 与教师端 TeacherPaperManageView.toLocalInput 一致，供 datetime-local 使用 */
    toLocalInput(value) {
      if (!value) return ''
      return String(value).replace('T', ' ').slice(0, 16).replace(' ', 'T')
    },
    openExamEditModal(item) {
      const exam = this.examItem(item)
      if (!exam || !exam.id) return
      this.examEditForm = {
        id: Number(exam.id),
        examName: exam.examName || '',
        paperId: Number(exam.paperId || 0) || null,
        startTime: this.toLocalInput(exam.startTime),
        endTime: this.toLocalInput(exam.endTime),
        participantUserIdsText: (item.participantUserIds || []).join(',')
      }
      this.examEditFeedback = null
      this.showExamEditModal = true
    },
    closeExamEditModal() {
      this.showExamEditModal = false
      this.examEditSaving = false
      this.examEditFeedback = null
      if (this.examEditSuccessTimer) {
        clearTimeout(this.examEditSuccessTimer)
        this.examEditSuccessTimer = null
      }
    },
    async saveExamEdit() {
      if (!this.examEditForm.id) return
      if (!this.examEditForm.examName || !this.examEditForm.paperId || !this.examEditForm.startTime || !this.examEditForm.endTime) {
        this.examEditFeedback = { ok: false, text: '请填写考试名称、试卷、开始时间、结束时间' }
        return
      }
      const participantUserIds = this.parseIds(this.examEditForm.participantUserIdsText)
      this.examEditSaving = true
      this.examEditFeedback = null
      try {
        const payload = {
          examName: String(this.examEditForm.examName).trim(),
          paperId: Number(this.examEditForm.paperId),
          startTime: this.examEditForm.startTime,
          endTime: this.examEditForm.endTime,
          participantUserIds
        }
        const r = await fetch(`/api/teacher/exam-manage/update/${this.examEditForm.id}`, {
          method: 'PUT',
          headers: this.authHeaders({ 'Content-Type': 'application/json' }),
          body: JSON.stringify(payload)
        })
        const raw = await r.text()
        let res = null
        try {
          res = raw ? JSON.parse(raw) : null
        } catch (e) {
          res = null
        }
        if (!r.ok || !res || res.code !== 200) {
          this.examEditFeedback = {
            ok: false,
            text: (res && res.message) || `保存失败（HTTP ${r.status}）`
          }
          return
        }
        this.loadExamList()
        this.examEditFeedback = {
          ok: true,
          text: '保存成功：考试信息已更新，列表已刷新。'
        }
        if (this.examEditSuccessTimer) clearTimeout(this.examEditSuccessTimer)
        this.examEditSuccessTimer = setTimeout(() => {
          this.examEditSuccessTimer = null
          this.closeExamEditModal()
        }, 1600)
      } catch (e) {
        this.examEditFeedback = { ok: false, text: '保存失败，请检查网络或稍后重试' }
        this.setPageError(e, '保存考试信息失败')
      } finally {
        this.examEditSaving = false
      }
    },
    openParticipantEditor(item) {
      const exam = this.examItem(item)
      if (!exam || !exam.id) return
      const ids = (item.participantUserIds || []).map((x) => Number(x)).filter((x) => Number.isFinite(x) && x > 0)
      this.participantEditor = {
        examId: Number(exam.id),
        examName: exam.examName || '',
        paperId: Number(exam.paperId || 0) || null,
        startTime: exam.startTime || '',
        endTime: exam.endTime || '',
        userIdsText: ids.join(','),
        usernamesText: '',
        userIds: ids
      }
      this.participantDetailRows = []
      this.participantDetailLoaded = false
      this.showParticipantEditor = true
      this.loadParticipantDetails(exam.id)
      this.$nextTick(() => {
        const el = this.$refs.participantInlinePanel
        if (el && typeof el.scrollIntoView === 'function') {
          el.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
        }
      })
    },
    closeParticipantEditor() {
      this.showParticipantEditor = false
      this.participantEditorSaving = false
      this.participantEditorResolving = false
      this.participantEditorImporting = false
      this.participantEditorExcelFile = null
      this.participantEditorImportSummary = ''
      this.participantDetailRows = []
      this.participantDetailLoading = false
      this.participantDetailLoaded = false
    },
    async loadParticipantDetails(examId) {
      if (!examId) return
      this.participantDetailLoading = true
      try {
        const res = await fetch(`/api/teacher/exam-manage/participants/${examId}`, {
          headers: this.authHeaders()
        }).then((r) => r.json())
        if (!res || res.code !== 200) {
          this.participantDetailRows = []
          this.participantDetailLoaded = true
          return
        }
        this.participantDetailRows = Array.isArray(res.data) ? res.data : []
        this.participantDetailLoaded = true
      } catch (e) {
        this.participantDetailRows = []
        this.participantDetailLoaded = true
      } finally {
        this.participantDetailLoading = false
      }
    },
    exportParticipantsForExam(examId, examName) {
      if (!examId) {
        window.alert('请先选择考试')
        return
      }
      fetch(`/api/teacher/exam-manage/participants/${examId}/export`, {
        headers: this.authHeaders()
      })
        .then(async (r) => {
          if (!r.ok) {
            let msg = '导出失败'
            try {
              const j = await r.json()
              if (j && j.message) msg = j.message
            } catch (e) {
              /* ignore */
            }
            throw new Error(msg)
          }
          return r.blob()
        })
        .then((blob) => {
          const a = document.createElement('a')
          const url = URL.createObjectURL(blob)
          a.href = url
          const safe = String(examName || 'exam').replace(/[\\/:*?"<>|]/g, '_')
          a.download = `exam_${examId}_participants_${safe}.xlsx`
          document.body.appendChild(a)
          a.click()
          a.remove()
          URL.revokeObjectURL(url)
        })
        .catch((e) => window.alert((e && e.message) || '导出学生名单失败'))
    },
    applyCurrentSelectionToEditor() {
      this.participantEditor.userIds = [...this.selectedUserIds]
      this.participantEditor.userIdsText = this.participantEditor.userIds.join(',')
    },
    appendCurrentSelectionToEditor() {
      const set = new Set((this.participantEditor.userIds || []).map((x) => Number(x)))
      this.selectedUserIds.forEach((id) => set.add(Number(id)))
      this.participantEditor.userIds = Array.from(set).filter((x) => Number.isFinite(x) && x > 0)
      this.participantEditor.userIdsText = this.participantEditor.userIds.join(',')
    },
    removeCurrentSelectionFromEditor() {
      const drop = new Set((this.selectedUserIds || []).map((x) => Number(x)))
      this.participantEditor.userIds = (this.participantEditor.userIds || []).filter((x) => !drop.has(Number(x)))
      this.participantEditor.userIdsText = this.participantEditor.userIds.join(',')
    },
    async appendParticipantsByUsernames() {
      const text = String(this.participantEditor.usernamesText || '').trim()
      if (!text) {
        window.alert('请先输入考试账号')
        return
      }
      this.participantEditorResolving = true
      try {
        const res = await fetch('/api/teacher/exam-manage/resolve-participants', {
          method: 'POST',
          headers: this.authHeaders({ 'Content-Type': 'application/json' }),
          body: JSON.stringify({ usernamesText: text })
        }).then((r) => r.json())
        if (!res || res.code !== 200) {
          window.alert((res && res.message) || '账号解析失败')
          return
        }
        const ids = Array.isArray(res.data && res.data.userIds) ? res.data.userIds : []
        const set = new Set((this.participantEditor.userIds || []).map((x) => Number(x)))
        ids.forEach((id) => {
          const n = Number(id)
          if (Number.isFinite(n) && n > 0) set.add(n)
        })
        this.participantEditor.userIds = Array.from(set)
        this.participantEditor.userIdsText = this.participantEditor.userIds.join(',')
        const skipped = Number((res.data && res.data.skipped) || 0)
        if (skipped > 0) {
          window.alert(`已追加 ${ids.length} 个账号，${skipped} 个账号未匹配学生用户`)
        }
      } catch (e) {
        this.setPageError(e, '账号解析失败')
        window.alert('账号解析失败')
      } finally {
        this.participantEditorResolving = false
      }
    },
    downloadParticipantTemplate() {
      fetch('/api/teacher/exam-manage/participants-template', {
        headers: this.authHeaders()
      })
        .then((r) => r.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = url
          a.download = 'exam_participants_template.xlsx'
          a.click()
          window.URL.revokeObjectURL(url)
        })
    },
    onParticipantExcelChange(e) {
      this.participantEditorExcelFile = (e.target.files && e.target.files[0]) || null
      this.participantEditorImportSummary = ''
    },
    async importParticipantsByExcel() {
      if (!this.participantEditorExcelFile) {
        window.alert('请先选择Excel文件')
        return
      }
      this.participantEditorImporting = true
      this.participantEditorImportSummary = ''
      try {
        const form = new FormData()
        form.append('file', this.participantEditorExcelFile)
        const res = await fetch('/api/teacher/exam-manage/import-participants', {
          method: 'POST',
          headers: this.authHeaders(),
          body: form
        }).then((r) => r.json())
        if (!res || res.code !== 200 || !res.data) {
          window.alert((res && res.message) || 'Excel导入失败')
          return
        }
        const ids = Array.isArray(res.data.userIds) ? res.data.userIds : []
        const set = new Set((this.participantEditor.userIds || []).map((x) => Number(x)))
        ids.forEach((id) => {
          const n = Number(id)
          if (Number.isFinite(n) && n > 0) set.add(n)
        })
        this.participantEditor.userIds = Array.from(set)
        this.participantEditor.userIdsText = this.participantEditor.userIds.join(',')
        const count = Number(res.data.count || ids.length || 0)
        const skipped = Number(res.data.skipped || 0)
        this.participantEditorImportSummary = `导入成功：新增/识别 ${count} 个账号，跳过 ${skipped} 个无效账号。`
        window.alert(this.participantEditorImportSummary)
      } catch (e) {
        this.setPageError(e, 'Excel导入失败')
        window.alert('Excel导入失败')
      } finally {
        this.participantEditorImporting = false
      }
    },
    async saveParticipantEditor() {
      if (!this.participantEditor.examId) return
      const participantUserIds = this.parseIds(this.participantEditor.userIdsText)
      this.participantEditorSaving = true
      try {
        const payload = {
          examName: this.participantEditor.examName,
          paperId: this.participantEditor.paperId,
          startTime: this.participantEditor.startTime,
          endTime: this.participantEditor.endTime,
          participantUserIds
        }
        const res = await fetch(`/api/teacher/exam-manage/update/${this.participantEditor.examId}`, {
          method: 'PUT',
          headers: this.authHeaders({ 'Content-Type': 'application/json' }),
          body: JSON.stringify(payload)
        }).then((r) => r.json())
        if (!res || res.code !== 200) {
          window.alert((res && res.message) || '保存参考人员失败')
          return
        }
        this.participantEditor.userIds = participantUserIds
        this.participantEditor.userIdsText = participantUserIds.join(',')
        this.loadParticipantDetails(this.participantEditor.examId)
        window.alert('参考人员已更新')
        this.loadExamList()
      } catch (e) {
        window.alert('保存参考人员失败')
        this.setPageError(e, '保存参考人员失败')
      } finally {
        this.participantEditorSaving = false
      }
    },
    async publishExam(id) {
      if (!id) return
      try {
        const r = await fetch(`/api/teacher/exam-manage/publish/${id}`, {
          method: 'POST',
          headers: this.authHeaders()
        })
        const raw = await r.text()
        let j = null
        try {
          j = raw ? JSON.parse(raw) : null
        } catch (e) {
          j = null
        }
        if (!r.ok || !j || j.code !== 200) {
          window.alert((j && j.message) || `发布失败（HTTP ${r.status}）`)
          return
        }
        const msg = j.data != null && String(j.data).trim() !== '' ? String(j.data) : '发布成功'
        window.alert(
          msg +
            '\n\n说明：「未开始/进行中/已结束」由当前时间与开考、结束时间决定；考试时段内发布后列表应显示进行中。'
        )
        this.loadExamList()
      } catch (e) {
        window.alert('发布失败，请检查网络或稍后重试')
        this.setPageError(e, '发布考试失败')
      }
    },
    async cancelExam(id) {
      if (!id) return
      try {
        const r = await fetch(`/api/teacher/exam-manage/cancel/${id}`, {
          method: 'POST',
          headers: this.authHeaders()
        })
        const raw = await r.text()
        let j = null
        try {
          j = raw ? JSON.parse(raw) : null
        } catch (e) {
          j = null
        }
        if (!r.ok || !j || j.code !== 200) {
          window.alert((j && j.message) || `取消失败（HTTP ${r.status}）`)
          return
        }
        window.alert(j.data != null && String(j.data).trim() !== '' ? String(j.data) : '已取消考试')
        this.loadExamList()
      } catch (e) {
        window.alert('取消失败，请检查网络或稍后重试')
        this.setPageError(e, '取消考试失败')
      }
    },
    async deleteExam(id) {
      if (!id) return
      if (!(await appConfirm('确认删除该考试吗？删除后不可恢复。'))) return
      try {
        const r = await fetch(`/api/teacher/exam-manage/delete/${id}`, {
          method: 'DELETE',
          headers: this.authHeaders()
        })
        const raw = await r.text()
        let j = null
        try {
          j = raw ? JSON.parse(raw) : null
        } catch (e) {
          j = null
        }
        if (!r.ok || !j || j.code !== 200) {
          window.alert((j && j.message) || `删除失败（HTTP ${r.status}）`)
          return
        }
        window.alert(j.data != null && String(j.data).trim() !== '' ? String(j.data) : '删除成功')
        this.loadExamList()
      } catch (e) {
        window.alert('删除失败，请检查网络或稍后重试')
        this.setPageError(e, '删除考试失败')
      }
    },
    async createExam(autoPublish) {
      if (!this.examForm.examName || !this.examForm.paperId || !this.examForm.startTime || !this.examForm.endTime) {
        window.alert('请完整填写考试名称、试卷、开始时间、结束时间')
        return
      }
      if (!this.selectedUserIds.length) {
        window.alert('请先勾选至少一名学生')
        return
      }
      this.savingExam = true
      try {
        const payload = {
          examName: String(this.examForm.examName).trim(),
          paperId: Number(this.examForm.paperId),
          startTime: this.examForm.startTime,
          endTime: this.examForm.endTime,
          participantUserIds: this.selectedUserIds.map((x) => Number(x)).filter((x) => Number.isFinite(x) && x > 0)
        }
        const createRes = await fetch('/api/teacher/exam-manage/create', {
          method: 'POST',
          headers: this.authHeaders({ 'Content-Type': 'application/json' }),
          body: JSON.stringify(payload)
        }).then((r) => r.json())
        if (!createRes || createRes.code !== 200) {
          window.alert((createRes && createRes.message) || '创建考试失败')
          return
        }
        const examId = createRes && createRes.data && createRes.data.id ? Number(createRes.data.id) : null
        if (autoPublish && examId) {
          await fetch(`/api/teacher/exam-manage/publish/${examId}`, {
            method: 'POST',
            headers: this.authHeaders()
          })
        }
        window.alert(autoPublish ? '考试已创建并发布' : '考试已创建')
        this.loadExamList()
      } catch (e) {
        window.alert('创建考试失败，请稍后重试')
        this.setPageError(e, '创建考试失败')
      } finally {
        this.savingExam = false
      }
    }
  },
  errorCaptured(err, instance, info) {
    this.setPageError(err, `页面渲染异常(${info || 'unknown'})`)
    return false
  }
}
</script>

<style scoped>
.city-paper-embedded-root,
.city-paper-embedded-main {
  width: 100%;
}

.city-paper-embedded-root :deep(.btn),
.content-area :deep(.btn) {
  border-radius: 10px !important;
  font-weight: 600 !important;
  transition: background-color 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease, transform 0.12s ease,
    filter 0.18s ease !important;
  box-shadow: none !important;
}

.city-paper-embedded-root :deep(.btn:hover),
.content-area :deep(.btn:hover) {
  transform: translateY(-1px);
  box-shadow: 0 6px 14px rgba(47, 111, 235, 0.16) !important;
}

.city-paper-embedded-root :deep(.btn:active),
.content-area :deep(.btn:active) {
  transform: translateY(0) !important;
  box-shadow: inset 0 2px 4px rgba(15, 23, 42, 0.12) !important;
  filter: brightness(0.96);
}

.city-paper-embedded-root :deep(.btn:focus-visible),
.content-area :deep(.btn:focus-visible) {
  outline: 0 !important;
  box-shadow: 0 0 0 0.2rem rgba(47, 111, 235, 0.28) !important;
}

.city-paper-embedded-root :deep(.btn:disabled),
.city-paper-embedded-root :deep(.btn.disabled),
.content-area :deep(.btn:disabled),
.content-area :deep(.btn.disabled) {
  opacity: 0.55 !important;
  transform: none !important;
  box-shadow: none !important;
  cursor: not-allowed !important;
}

.city-paper-embedded-root :deep(.btn-primary),
.content-area :deep(.btn-primary) {
  background: linear-gradient(120deg, #2f6feb, #5ca2ff) !important;
  border-color: #2f6feb !important;
  color: #fff !important;
}

.city-paper-embedded-root :deep(.btn-primary:hover),
.content-area :deep(.btn-primary:hover) {
  background: linear-gradient(120deg, #2762d6, #4f96f5) !important;
  border-color: #2762d6 !important;
  color: #fff !important;
}

.city-paper-embedded-root :deep(.btn-light),
.content-area :deep(.btn-light) {
  background: #edf4ff !important;
  border-color: #c8dcff !important;
  color: #2f5da5 !important;
}

.city-paper-embedded-root :deep(.btn-light:hover),
.content-area :deep(.btn-light:hover) {
  background: #deebff !important;
  border-color: #b4d0ff !important;
  color: #244f90 !important;
}

.city-paper-embedded-root :deep(.btn-danger),
.city-paper-embedded-root :deep(.ticket-danger-btn),
.content-area :deep(.btn-danger),
.content-area :deep(.ticket-danger-btn) {
  background: #dc3545 !important;
  border-color: #dc3545 !important;
  color: #fff !important;
}

.city-paper-embedded-root :deep(.btn-danger:hover),
.city-paper-embedded-root :deep(.ticket-danger-btn:hover),
.content-area :deep(.btn-danger:hover),
.content-area :deep(.ticket-danger-btn:hover) {
  background: #c82333 !important;
  border-color: #bd2130 !important;
  color: #fff !important;
  box-shadow: 0 8px 16px rgba(220, 53, 69, 0.22) !important;
}

.city-paper-card {
  border-radius: 14px;
}

.ticket-section {
  padding: 18px !important;
}

.ticket-section-head {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px 16px;
  margin-bottom: 16px;
}

.ticket-section-head__text {
  flex: 1 1 240px;
  min-width: 0;
}

.ticket-section-title {
  margin: 0 0 8px !important;
  font-size: 1.1rem;
  line-height: 1.35;
  color: #1f2a44 !important;
}

.ticket-section-desc {
  margin: 0 !important;
  padding: 0;
  max-width: 760px;
  font-size: 13px;
  line-height: 1.65;
  color: #5c7098 !important;
}

.ticket-section-head__action {
  flex: 0 0 auto;
  margin-top: 2px;
}

.ticket-form-panel {
  padding: 16px;
  border: 1px solid #d7e6ff;
  border-radius: 12px;
  background: linear-gradient(180deg, #f7fbff 0%, #eef5ff 100%);
}

.ticket-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.ticket-field-label {
  display: block;
  margin: 0 !important;
  padding: 0;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.4;
  color: #4a628c !important;
}

.ticket-form-panel :deep(.form-control),
.ticket-form-panel :deep(.form-select),
.participant-edit-card :deep(.form-control),
.participant-edit-card :deep(.form-select),
.city-exam-edit-modal :deep(.form-control),
.city-exam-edit-modal :deep(.form-select) {
  min-height: 40px;
  padding: 0.5rem 0.75rem !important;
  border-color: #cfe0ff !important;
  background-color: #fff !important;
}

.ticket-form-panel :deep(textarea.form-control),
.participant-edit-card :deep(textarea.form-control),
.city-exam-edit-modal :deep(textarea.form-control) {
  min-height: 96px;
  line-height: 1.5;
}

.ticket-form-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid #d7e6ff;
}

.ticket-selected-count {
  margin-right: auto;
  font-size: 13px;
  font-weight: 600;
  color: #355b9f;
}

.ticket-stats-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 10px;
  padding: 12px 14px;
  border: 1px dashed #c6dbff;
  border-radius: 12px;
  background: #f5f9ff;
  color: #355b9f;
  line-height: 1.5;
}

.ticket-check {
  display: inline-flex;
  align-items: flex-start;
  gap: 8px;
  margin: 0;
  padding: 8px 12px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.72);
  border: 1px solid #d7e6ff;
}

.ticket-check .form-check-input {
  margin-top: 0.2rem;
  flex: 0 0 auto;
}

.ticket-check .form-check-label {
  margin: 0;
  line-height: 1.5;
  color: #355b9f;
  font-size: 13px;
}

.ticket-cell-wrap {
  white-space: normal !important;
  word-break: break-word;
  min-width: 120px;
  max-width: 280px;
  line-height: 1.45;
}

.ticket-action-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.ticket-status-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.3;
  border: 1px solid transparent;
}

.ticket-status-badge.is-on {
  background: #e8f8ee;
  border-color: #b7e4c7;
  color: #1b7a3d;
}

.ticket-status-badge.is-off {
  background: #f1f4f8;
  border-color: #d5dde8;
  color: #5c6b82;
}

.ticket-status-badge.is-pending {
  background: #fff7e8;
  border-color: #f0d7a3;
  color: #9a6b12;
}

.city-paper-result-shell {
  border-radius: 12px;
  border: 1px solid #dbe8ff;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  overflow: auto;
  padding: 4px;
}

.city-paper-result-shell :deep(.modern-table thead th) {
  background: #edf4ff !important;
  color: #2a4f90 !important;
  padding: 12px 14px !important;
}

.city-paper-result-shell :deep(.modern-table tbody td) {
  padding: 12px 14px !important;
  vertical-align: middle !important;
}

.city-paper-result-shell :deep(.modern-table tbody tr:hover td) {
  background: #f3f8ff !important;
}

.city-paper-card :deep(.form-control),
.city-paper-card :deep(.form-select) {
  border-color: #cfe0ff !important;
  background-color: #fff !important;
}

.city-paper-card :deep(.form-control:focus),
.city-paper-card :deep(.form-select:focus) {
  border-color: #79a7ff !important;
  box-shadow: 0 0 0 0.2rem rgba(82, 136, 240, 0.16) !important;
}

.participant-card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 14px;
}

.participant-edit-card {
  border: 1px solid #d7e6ff;
  border-radius: 12px;
  background: linear-gradient(180deg, #f8fbff 0%, #eef5ff 100%);
  padding: 14px;
}

.participant-edit-card__title {
  font-size: 13px;
  font-weight: 700;
  color: #2d4f87;
  margin-bottom: 12px;
  line-height: 1.4;
}

.city-paper-participant-inline {
  border: 1px solid #d8e6ff;
  border-radius: 14px;
  padding: 16px 18px;
  background: linear-gradient(165deg, rgba(255, 255, 255, 0.98), rgba(244, 250, 255, 0.98));
  box-shadow: 0 4px 18px rgba(35, 72, 150, 0.08);
  max-height: min(70vh, 900px);
  overflow: auto;
}

.city-paper-modal-mask {
  position: fixed;
  inset: 0;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  margin: 0;
  box-sizing: border-box;
  background: rgba(18, 36, 76, 0.45);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  z-index: 2147483000;
}

.modal-panel {
  border-radius: 14px !important;
  width: min(720px, 100%);
  max-height: calc(100vh - 40px);
  overflow: auto;
  background: linear-gradient(165deg, rgba(255, 255, 255, 0.98), rgba(244, 250, 255, 0.98));
  border: 1px solid #d8e6ff;
  padding: 18px;
  box-shadow: 0 20px 50px rgba(35, 72, 150, 0.25);
}

.city-exam-edit-modal {
  max-width: min(96vw, 920px);
  width: 100%;
}

.city-paper-modal-mask :deep(.btn) {
  border-radius: 10px !important;
  font-weight: 600 !important;
}

.city-paper-modal-mask :deep(.btn-primary) {
  background: linear-gradient(120deg, #2f6feb, #5ca2ff) !important;
  border-color: #2f6feb !important;
  color: #fff !important;
}

.city-paper-modal-mask :deep(.btn-light) {
  background: #edf4ff !important;
  border-color: #c8dcff !important;
  color: #2f5da5 !important;
}
</style>

